module.exports = __webpack_public_path__ + "img/instagram.097b7749.png";